module.exports = __webpack_public_path__ + "img/answer6.6064ba81.jpg";